module.exports = __webpack_public_path__ + "img/base_activites_tir.d42a8b57.svg";